import { Component  } from 'react';
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  getClientForm,
  saveClientResponse,
  saveClientResponseDraft,
  getClientFccData,
  getClientSipnavConfig,
} from "./../../../config/forms_api_calls";
import { APP_LIVE_URL, API_URL, APP_URL } from "./../../../config/config";
import $ from "jquery";

import DataTableExtended from "../../../components/Tables/DataTableExtended";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import Typography from "@material-ui/core/Typography";
import FormRendererClient from "../../../components/Client/formRenderClient";
import NotificationToast from "../../../components/Notification/NotificationToast";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import dateFormat from "dateformat";

const auth = new HelperClass();

class FormSubmit extends Component {
  constructor() {
    super();

    this.state = {
      tableData: [],
      tableDataSingle: [],
      serviceData: [],
      tableLoaderListing: true,
      tableLoader: true,
      errorMessage: "",
      successMessage: "",
      showModal: false,
      modalContent: null,
      formAccNo: "",
      successMessageSaveResponse: "",
      errorMessageSaveResponse: "",
      form_accountno: "",
      form_token: "",
      formData: "",
      form_title: "",
      form_desc: "",
      client_details: [],
      form_submitted: "3",
      allow_multiple: 0,
      responseMessage: "",
      allow_submit: 1,
      link_form: false,
      captcha_enabled: 0,
      external_link: "",
      draftData: [],
      progressStep: 0,
      totalSteps: 0,
      service_data: [],
      service_id: "",
      fcc_data: null,
      sipnav_data: null,
      toastMessage: "",
      toastType: "success",
      toastTitle: "",
      apiFieldErrors: null,
    };
  }

  showToast = (message, type = "error", title) => {
    this.setState({ toastMessage: "" }, () =>
      this.setState({
        toastMessage: message,
        toastType: type,
        toastTitle: title || (type === "success" ? "Success" : "Error"),
      })
    );
  };

  async componentDidMount() {
    let form_accountno = this.props.props.match.params.form_accountno;
    let form_token = this.props.props.match.params.form_token;
    let service_id = this.props.props.match.params.service_id;
    this.setState({
      formAccNo: form_accountno,
      form_token: form_token,
      service_id: service_id,
    });
    const servicesResponce = await getClientForm(
      auth.getClientAccount(),
      auth.getClientToken(),
      form_accountno,
      form_token
    );
    // console.log("getClientForm: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
        form_submitted: "3",
      });
    } else if (servicesResponce.data.status === 200) {
      if (servicesResponce.data.is_ai_agent_form === true) {
        this.setState({
          link_form: 1,                           // forces "Link Only" UI
          external_link: servicesResponce.data.data.external_link,
          tableLoader: false,
          tableLoaderListing: false,
          form_submitted: "AI_AGENT",             // bypass normal flow
        });
        return; // ⛔ Prevent normal form rendering
      }
      let from_table = servicesResponce.data.from_table;
      const groupsData = servicesResponce.data.data[0]["groups"];
      const groups = groupsData ? JSON.parse(groupsData) : [];

      const draftResponse = servicesResponce.data.draft_response;
      const draftData =
        draftResponse && draftResponse !== "" ? JSON.parse(draftResponse) : [];
      let progress = "";

      if (from_table === "main") {
        progress = servicesResponce.data.client_data[0]["progress"];
      } else if (from_table === "submission") {
        progress = servicesResponce.data.progress;
      }
      // console.log("progress: ", progress);
      let progressStep = 0;
      if (progress) {
        const [current, total] = progress.split("/").map(Number);
        progressStep = current < total ? current : 0;
      }

      let form_submitted = 0;
      let allow_multiple = 0;
      if (from_table === "main") {
        form_submitted = servicesResponce.data.client_data[0]["is_filled"];
        allow_multiple = servicesResponce.data.client_data[0]["allow_multiple"];
      } else {
        if (servicesResponce.data.is_submitted === 0) {
          form_submitted = "No";
        } else if (servicesResponce.data.is_submitted === 1) {
          form_submitted = "Yes";
        }

        allow_multiple = servicesResponce.data.data[0]["allow_multiple"];
      }

      this.setState({
        formData: servicesResponce.data.data[0]["form_content"],
        form_title: servicesResponce.data.data[0]["form_title"],
        form_desc: servicesResponce.data.data[0]["form_desc"],
        allow_submit: servicesResponce.data.data[0]["allow_submit"],
        link_form: servicesResponce.data.data[0]["link_form"],
        captcha_enabled: servicesResponce.data.data[0]["captcha_enabled"] || 0,
        external_link: servicesResponce.data.data[0]["external_link"],
        groups: groups,
        client_details: servicesResponce.data.client_details,
        service_data: servicesResponce.data.service_data
          ? servicesResponce.data.service_data
          : [],
        form_submitted: form_submitted,
        allow_multiple: allow_multiple,
        draftData: draftData,
        totalSteps: groups.length,
        progressStep: progressStep,
        tableLoader: false,
        tableLoaderListing: false,
      });

      // Fetch FCC data for dynamic field autofill
      try {
        const fccResponse = await getClientFccData(
          auth.getClientAccount(),
          auth.getClientToken()
        );
        if (
          fccResponse.data.status === 200 &&
          fccResponse.data.fcc_data
        ) {
          this.setState({ fcc_data: fccResponse.data.fcc_data });
        }
      } catch (e) {
        // FCC data fetch failed, keep null
      }

      // Fetch SIPNav config for dynamic field autofill (only for SIPNav forms)
      const isSipnavForm =
        servicesResponce.data.data[0]["is_sipnav"] === 1 ||
        servicesResponce.data.data[0]["is_sipnav"] === "1";
      if (isSipnavForm && servicesResponce.data.client_details) {
        try {
          const resellerAccountno =
            servicesResponce.data.client_details[0]["reseller_accountno"];
          const sipnavResponse = await getClientSipnavConfig(
            auth.getClientAccount(),
            auth.getClientToken(),
            resellerAccountno
          );
          if (
            sipnavResponse.data.status === 200 &&
            sipnavResponse.data.sipnav_data
          ) {
            this.setState({ sipnav_data: sipnavResponse.data.sipnav_data });
          }
        } catch (e) {
          // SIPNav config fetch failed, keep null
        }
      }
    } else {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
        form_submitted: "3",
      });
      //window.location.replace("/error");
    }
  }

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy, h:MM:ss TT");
  };

  handleChange = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  openModal = (formData, formAccNo) => {
    const modalContent = (
      <FormRendererClient
        formData={JSON.parse(formData)}
        formTitle={this.state.form_title}
        onSubmit={this.handleSubmitForm}
        captcha_enabled={this.state.captcha_enabled}
        link_form={this.state.link_form}
      // id={this.state.forms[0].id}
      // setShowResponse={(value) => this.setState({ showResponse: value })}
      />
    );
    this.setState({ modalContent: modalContent, formAccNo: formAccNo }, () => {
      window.$("#modalPreviewForm").modal("show");
    });
  };

  closeModal = () => {
    this.setState({ modalContent: null, formAccNo: "" }, () => {
      window.$("#modalPreviewForm").modal("hide");
    });
  };

  handleSaveDraft = (formData, currentStep) => {
    let response = JSON.stringify(formData);
    let form_accountno = this.props.props.match.params.form_accountno;
    const draft_result = this.saveDraft(response, form_accountno, currentStep);
    return draft_result;
  };

  saveDraft = async (response, formAccNo, submittedStep) => {
    const { form_token, form_title, form_desc, totalSteps } = this.state;
    window.scrollTo({ top: 0, behavior: "smooth" });
    const submitFormReponse = await saveClientResponseDraft(
      auth.getClientAccount(),
      response,
      formAccNo,
      form_token,
      form_title,
      form_desc,
      submittedStep,
      totalSteps
    );
    // console.log("saveResponse response: ", submitFormReponse.data);
    if (
      submitFormReponse.data.status === 403 ||
      submitFormReponse.data.errors === "authentication missing" ||
      submitFormReponse.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (submitFormReponse.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        responseMessage:
          '<div className="alert alert-danger alert-icon mb-3"><em className="icon ni ni-cross-circle"></em> There is some error while saving the progress.</div>',
      });
      return false;
    } else if (submitFormReponse.data.status === 200) {
      let formToken = submitFormReponse.data.form_token;

      /*if (submittedStep === 1) {
        window.location.href =
          APP_URL +
          auth.getResellerRegToken() +
          "/client/client_form_submit/" +
          formAccNo +
          "/" +
          formToken;
      }*/
      return true;
    }
    setTimeout(() => {
      this.setState({
        errorMessageSaveResponse: "",
        responseMessage: "",
      });
    }, 5000);
  };

  handleSubmitForm = (formData, selectedServices) => {
    let response = JSON.stringify(formData);
    this.saveResponse(response, this.state.formAccNo, selectedServices);
  };

  saveResponse = async (response, formAccNo, selectedServices) => {
    const { form_token, form_title, form_desc, totalSteps, service_id } =
      this.state;
    this.setState({ apiFieldErrors: null });
    window.scrollTo({ top: 0, behavior: "smooth" });
    try {
      const submitFormReponse = await saveClientResponse(
        auth.getClientAccount(),
        auth.getClientToken(),
        response,
        formAccNo,
        form_token,
        form_title,
        form_desc,
        totalSteps,
        service_id,
        selectedServices
      );
      // console.log("saveResponse response: ", submitFormReponse.data);
      const data = submitFormReponse.data || {};

      if (
        data.status === 403 ||
        data.errors === "authentication missing" ||
        data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } else if (data.status === 404) {
        const fieldErrors = data.field_errors;
        if (fieldErrors && typeof fieldErrors === "object") {
          const firstError = Object.values(fieldErrors)
            .flat()
            .find((msg) => typeof msg === "string" && msg.trim() !== "");
          const fallbackMsg =
            (typeof data.errors === "string" ? data.errors : data.errors?.message) ||
            data.message ||
            "There is some error while submitting the form.";
          this.showToast(firstError || fallbackMsg, "error");
        } else {
          const msg =
            (typeof data.errors === "string" ? data.errors : data.errors?.message) ||
            data.message ||
            "There is some error while submitting the form.";
          this.showToast(msg, "error");
        }
      } else if (data.status === 200) {
        this.setState({ errorMessageSaveResponse: "", apiFieldErrors: null });
        this.showToast(
          "Your response was submitted successfully!",
          "success",
          "Submitted"
        );
        setTimeout(() => {
          // Redirect to orders page if an order was created, otherwise to forms page
          const redirectPath = data.orderCreated
            ? "/" + auth.getResellerRegToken() + "/client/SalesOrders"
            : "/" + auth.getResellerRegToken() + "/client/forms";
          this.props.props.history.push(redirectPath);
          //window.location.reload();
        }, 3500);
      } else {
        // Any other backend status (e.g. 405) — surface the error to the user.
        const msg =
          (typeof data.errors === "string" ? data.errors : data.errors?.message) ||
          data.message ||
          "There was an error while submitting the form.";
        this.showToast(msg, "error");
      }
    } catch (err) {
      const msg =
        err?.response?.data?.errors?.message ||
        (typeof err?.response?.data?.errors === "string"
          ? err.response.data.errors
          : null) ||
        err?.response?.data?.message ||
        err?.message ||
        "There was an unexpected error while submitting the form.";
      this.showToast(msg, "error");
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  render() {
    const { step } = this.state;
    const { email, VerifyUsernameButton } = this.state;
    const values = {
      email,
      VerifyUsernameButton,
    };
    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");
    return (
      <div className="nk-content" id="Support_Block" style={{ background: "#eef1f7" }}>
        <NotificationToast
          message={this.state.toastMessage}
          type={this.state.toastType}
          title={this.state.toastTitle}
          onDismiss={() => this.setState({ toastMessage: "" })}
        />
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" &&
            this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" &&
            this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              {/* RIGHTS MODAL START */}

              {/* RIGHTS MODAL End */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <Breadcrumbs aria-label="breadcrumb">
                      <Link
                        color="inherit"
                        onClick={() =>
                          this.addMenuHistory(
                            "/" + auth.getResellerRegToken() + "/client/"
                          )
                        }
                        className=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <HomeIcon fontSize="inherit" className="" />
                        Home
                      </Link>
                      <Link
                        color="inherit"
                        onClick={() =>
                          this.addMenuHistory(
                            "/" + auth.getResellerRegToken() + "/client/forms"
                          )
                        }
                        className=""
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        Forms
                      </Link>

                      <Typography color="textPrimary" className="">
                        Submit Form
                      </Typography>
                    </Breadcrumbs>
                  </div>
                  {/* <div className="nk-block-head-content" id="HeadContent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                    </div>
                  </div> */}
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-gs">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12 form_main_container">
                    <div className="nk-block nk-block-lg">
                      <div style={{ background: "transparent" }}>
                        <div>
                          {this.state.tableLoader === true ? (
                            TableLoader()
                          ) : (
                            <>
                              {this.state.link_form === 1 ? (
                                <div className="nk-block mt-4">
                                  <div className="nk-block-content nk-error-ld">
                                    <h3 className="nk-error-title text-center">
                                      Link Only
                                    </h3>
                                    <div className="alert alert-light text-dark">
                                      This form contains an external link.{" "}
                                      <a
                                        href={this.state.external_link}
                                        target="_blank"
                                      >
                                        Click Here
                                      </a>{" "}
                                      to be redirected to the specified
                                      destination.
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  {this.state.form_submitted === "No" ? (
                                    <FormRendererClient
                                      formData={JSON.parse(this.state.formData)}
                                      formTitle={this.state.form_title}
                                      formDescription={this.state.form_desc}
                                      onSubmit={this.handleSubmitForm}
                                      onToast={this.showToast}
                                      groups={this.state.groups}
                                      responseMessage={
                                        this.state.responseMessage
                                      }
                                      clientData={this.state.client_details}
                                      allow_submit={this.state.allow_submit}
                                      draftData={this.state.draftData}
                                      saveDraft={this.handleSaveDraft}
                                      progressStep={this.state.progressStep}
                                      viewFrom="client-logged-in"
                                      service_data={this.state.service_data}
                                      service_id={this.state.service_id}
                                      captcha_enabled={this.state.captcha_enabled}
                                      link_form={this.state.link_form}
                                      fccData={this.state.fcc_data}
                                      sipnavData={this.state.sipnav_data}
                                    //id={this.state.forms[0].id}
                                    //setShowResponse={(value) => this.setState({ showResponse: value })}
                                    />
                                  ) : this.state.form_submitted === "Yes" ? (
                                    <>
                                      {this.state.allow_multiple === 1 ? (
                                        <FormRendererClient
                                          formData={JSON.parse(
                                            this.state.formData
                                          )}
                                          formTitle={this.state.form_title}
                                          formDescription={this.state.form_desc}
                                          onSubmit={this.handleSubmitForm}
                                          onToast={this.showToast}
                                          groups={this.state.groups}
                                          responseMessage={
                                            this.state.responseMessage
                                          }
                                          clientData={this.state.client_details}
                                          allow_submit={this.state.allow_submit}
                                          draftData={this.state.draftData}
                                          saveDraft={this.handleSaveDraft}
                                          progressStep={this.state.progressStep}
                                          viewFrom="client-logged-in"
                                          service_data={this.state.service_data}
                                          service_id={this.state.service_id}
                                          captcha_enabled={this.state.captcha_enabled}
                                          link_form={this.state.link_form}
                                          fccData={this.state.fcc_data}
                                          sipnavData={this.state.sipnav_data}
                                        //id={this.state.forms[0].id}
                                        //setShowResponse={(value) => this.setState({ showResponse: value })}
                                        />
                                      ) : this.state.allow_multiple === 0 ? (
                                        <div className="nk-block mt-4">
                                          <div className="nk-block-content nk-error-ld">
                                            <h3 className="nk-error-title text-center">
                                              Form Submitted
                                            </h3>
                                            <div className="alert alert-light text-dark">
                                              Thank you for submitting your
                                              form. We have successfully
                                              received your information and are
                                              processing it. Our team will
                                              review the details and get back to
                                              you shortly if further information
                                              is needed. We appreciate your time
                                              and effort in providing us with
                                              the necessary details.
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                    </>
                                  ) : this.state.form_submitted === "3" ? (
                                    <div className="nk-block mt-4">
                                      <div className="nk-block-content nk-error-ld  text-center">
                                        <h3 className="nk-error-title">
                                          Form Unavailable
                                        </h3>
                                        <div className="alert alert-light text-dark">
                                          We are very sorry for inconvenience.
                                          It looks like you’re try to access a
                                          form that either has been expired or
                                          already submitted.
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                </>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FormSubmit);
